import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import Delivery from './Delivery.vue';
import Faq from './Faq.vue';
import Payment from './Payment.vue';
import Phone from './Phone.vue';
import Return from './Return.vue';
import TrustedShops from './TrustedShops.vue';
import TrustPilot from './TrustPilot.vue';
export default {
  name: 'Reinsurance',
  components: {
    Delivery: Delivery,
    Faq: Faq,
    Payment: Payment,
    Phone: Phone,
    Return: Return,
    TrustedShops: TrustedShops,
    TrustPilot: TrustPilot
  },
  data: function data() {
    return {};
  },
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  }), {
    defaultShowcase: function defaultShowcase() {
      return this.locale.iso === 'fr-FR' || this.locale.iso === 'it-IT';
    }
  })
};